export default __webpack_public_path__ + "static/media/arrowUp.5f8fc15a.svg";